import { render, staticRenderFns } from "./FrequentlyAskQuestions.vue?vue&type=template&id=1030c904"
import script from "./FrequentlyAskQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports